<template>
  <div class="m-loggedBox">
    <button class="m-loggedBox__returnButton" @click="volver">Volver</button>
    <div class="m-loggedBox__title">
      Logged
    </div>
    <div class="m-loggedBox__token" v-if="token != ''">
      <b>Token: </b>{{token}}
    </div>
     <div class="m-loggedBox__username" v-if="username != ''">
      <b>Wellcome: </b>{{username}}
    </div>
    <div class="m-loggedBox__data" v-if="data != ''">
      {{data}}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeMount } from "vue";
import {Linkedin, userLinkedin} from '../Login/LinkedinLogin';

export default defineComponent({
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data(){
    return{
      token: "",
      username: "",
      data: "",
    }
  },
  mounted(){
    console.log("mounted")
    this.showTokens();
  },
  methods:{
    showTokens(){
      if(this.$route.params.response == 'gitlab'){
        const url = new URL(window.location.href.replace(/#/g,"?"));
        const token = url.searchParams.get("access_token")?.toString();
        this.token = token? token : 'No token' 
      }
      if(this.$route.params.response == 'github'){
        const url = new URL(window.location.href);
        const token = url.searchParams.get("code")?.toString();
        this.token = token? token : 'No token' 
      }
      // if(this.$route.params.response == 'yahoo'){
      //   const url = new URL(window.location.href);
      //   const token = url.searchParams.get("code")?.toString();
      //   this.token = token? token : 'No token' 
      // }
      if(this.$route.params.response == 'thelinkedin'){
        if(Linkedin()) this.asignarUsuario();
      }

      if(this.$route.params.response == 'google') this.asignarUsuario();  

    },
    volver(){
      this.$router.push({name: 'SocialLogin'});
    },
    asignarUsuario(){
      this.username = localStorage.getItem('USERNAME') || 'No username';
      this.data = localStorage.getItem('DATA') || 'No data';
    }
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.m-loggedBox{
  width: 500px;
  text-align: center;

  &__user{
    padding: 10px;
  }

  &__returnButton{
    width: 200px;
    padding: 8px;
    margin: 20px;
    
    background: goldenrod;
    border: none;
    border-radius: 13px;
    box-shadow: 2px 4px 4px rgba(0,0,0,0.5);

    font-size: 16px;
    color: white;
    font-weight: bold;

    cursor: pointer;
  }
}
</style>
